class HTMLUpdateUtility {
  static viewTransition(
    oldNode: any,
    newContent: any,
    preProcessCallbacks: Array<(node: any) => void> = [],
    postProcessCallbacks: Array<(node: any) => void> = [],
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild as any;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element: any) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          'form',
          `${element.form.getAttribute('id')}-${uniqueKey}`,
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element: any, html: string) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag: any) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute: any) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  static prependSectionId(container: HTMLElement, sectionId: string) {
    container.querySelectorAll('[id]').forEach((element) => {
      element.id = `${element.id}-${sectionId}`;
    });
    container.querySelectorAll('[form]').forEach((element) => {
      element.setAttribute('form', `${element.getAttribute('form')}-${sectionId}`);
    });
  }
}

const attachHTMLUpdateUtilityToWindow = () => {
  (window as any).HTMLUpdateUtility = HTMLUpdateUtility;
};

export { HTMLUpdateUtility, attachHTMLUpdateUtilityToWindow };
